import { useState } from "react";
import { CalcCard, NumField, ResultRow, PrimaryButton, Section, SaveButton } from "@/components/CalcUI";
import { runCalc } from "@/lib/api";
import { toast } from "sonner";

export default function MudWeight() {
  const [wu, setWu] = useState({ v1: "500", w1: "10.0", w2: "11.5" });
  const [wuOut, setWuOut] = useState(null);

  const [wd, setWd] = useState({ v1: "500", w1: "12.0", w2: "10.5", dilution_w: "8.33" });
  const [wdOut, setWdOut] = useState(null);

  const run = async (calc, inp, setter) => {
    try {
      const r = await runCalc(calc, Object.fromEntries(Object.entries(inp).map(([k, v]) => [k, parseFloat(v)])));
      setter(r);
    } catch (e) {
      toast.error("Invalid inputs");
    }
  };

  return (
    <div data-testid="mud-weight-page">
      <Section title="Mud Weight" subtitle="Weight-up with barite (SG 4.2) or weight-down with water/base fluid. Rule-of-thumb formulas — always cross-check with rig chemist and pit volumes.">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <CalcCard testid="wu-card" title="Weight Up (Barite)" formula="Sx/bbl = 14.7·(w2−w1)/(35−w2)">
            <div className="grid grid-cols-3 gap-3">
              <NumField testid="wu-v1" label="Volume" unit="bbl" value={wu.v1} onChange={(v) => setWu({ ...wu, v1: v })} />
              <NumField testid="wu-w1" label="Current MW" unit="ppg" value={wu.w1} onChange={(v) => setWu({ ...wu, w1: v })} />
              <NumField testid="wu-w2" label="Target MW" unit="ppg" value={wu.w2} onChange={(v) => setWu({ ...wu, w2: v })} />
            </div>
            <div className="mt-4 flex justify-between">
              <PrimaryButton testid="wu-run" onClick={() => run("weight_up", wu, setWuOut)}>Calculate</PrimaryButton>
              <SaveButton getPayload={() => wuOut && { category: "Mud Weight", calculator: "weight_up", inputs: wu, outputs: wuOut, units: "field", default_name: "Weight up" }} />
            </div>
            {wuOut && (
              <div className="mt-4 border-t border-[#334155] pt-3">
                <ResultRow label="Barite sacks" value={wuOut.barite_sacks} unit="sk" emphasis />
                <ResultRow label="New volume" value={wuOut.new_volume_bbl} unit="bbl" />
              </div>
            )}
          </CalcCard>

          <CalcCard testid="wd-card" title="Weight Down (Dilution)" formula="V_add = V1·(w1−w2)/(w2−wD)">
            <div className="grid grid-cols-2 gap-3">
              <NumField testid="wd-v1" label="Volume" unit="bbl" value={wd.v1} onChange={(v) => setWd({ ...wd, v1: v })} />
              <NumField testid="wd-w1" label="Current MW" unit="ppg" value={wd.w1} onChange={(v) => setWd({ ...wd, w1: v })} />
              <NumField testid="wd-w2" label="Target MW" unit="ppg" value={wd.w2} onChange={(v) => setWd({ ...wd, w2: v })} />
              <NumField testid="wd-wd" label="Dilution wt" unit="ppg" value={wd.dilution_w} onChange={(v) => setWd({ ...wd, dilution_w: v })} />
            </div>
            <div className="mt-4"><PrimaryButton testid="wd-run" onClick={() => run("weight_down", wd, setWdOut)}>Calculate</PrimaryButton></div>
            {wdOut && (
              <div className="mt-4 border-t border-[#334155] pt-3">
                <ResultRow label="Dilution volume" value={wdOut.dilution_volume_bbl} unit="bbl" emphasis />
                <ResultRow label="Final volume" value={wdOut.final_volume_bbl} unit="bbl" />
              </div>
            )}
          </CalcCard>
        </div>
      </Section>
    </div>
  );
}
